"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityNotifyDto = instanceOfOrientationOpportunityNotifyDto;
exports.OrientationOpportunityNotifyDtoFromJSON = OrientationOpportunityNotifyDtoFromJSON;
exports.OrientationOpportunityNotifyDtoFromJSONTyped = OrientationOpportunityNotifyDtoFromJSONTyped;
exports.OrientationOpportunityNotifyDtoToJSON = OrientationOpportunityNotifyDtoToJSON;
exports.OrientationOpportunityNotifyDtoToJSONTyped = OrientationOpportunityNotifyDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationOpportunityNotifyDto interface.
 */
function instanceOfOrientationOpportunityNotifyDto(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityNotifyDtoFromJSON(json) {
    return OrientationOpportunityNotifyDtoFromJSONTyped(json, false);
}
function OrientationOpportunityNotifyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
    };
}
function OrientationOpportunityNotifyDtoToJSON(json) {
    return OrientationOpportunityNotifyDtoToJSONTyped(json, false);
}
function OrientationOpportunityNotifyDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
    };
}
//# sourceMappingURL=OrientationOpportunityNotifyDto.js.map